/**
 * Single provider row with title, description, and an on/off toggle.
 */

export function ProviderToggleRow(props: {
  title: string;
  description: string;
  enabled: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="flex items-center justify-between rounded-xl border border-stone-200 p-3 dark:border-stone-700">
      <div>
        <div className="text-sm font-medium text-stone-700 dark:text-stone-300">{props.title}</div>
        <div className="text-xs text-stone-500 dark:text-stone-400">{props.description}</div>
      </div>
      <button
        role="switch"
        aria-checked={props.enabled}
        onClick={props.onToggle}
        className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors ${
          props.enabled ? 'bg-primary' : 'bg-stone-300 dark:bg-stone-600'
        }`}
      >
        <span
          className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transition-transform ${
            props.enabled ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </button>
    </div>
  );
}
